import React from "react";

export default function IconOfferBg({ className = "" }) {
  return (
    <svg
      className={`offer-bg ${className}`}
      viewBox="0 0 2594 1797"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient
          id="paint0_linear_192_4"
          x1="1297.25"
          y1="0.5"
          x2="1297.25"
          y2="1796.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFC032" />
          <stop offset="0.5" stopColor="#FF0000" />
          <stop offset="1" stopColor="#513F95" />
        </linearGradient>
      </defs>

      <path
        id="Vector1"
        className="draw-path"
        d="M1208.5 898.5C1603.5 712.5 16.1667 366.833 0.5 0.5H2594V1796.5C2594 1796.5 689.5 1750 1510.5 1417C2331.5 1084 813.5 1084.5 1208.5 898.5Z"
        stroke="url(#paint0_linear_192_4)"
        strokeWidth="4"
        fill="none"
      />
    </svg>
  );
}
